import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ToDoList from "./todo/components/ToDoList";
import { ToDoContext } from "./todo/contexts/ToDoContext";
import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { SnackBarPovider } from "./todo/contexts/SnackBarContext";
import ToDoProvider from "./todo/contexts/ToDoContext";

const theme = createTheme({
  typography: {
    fontFamily: "Alexandria",
  },
  palette: {
    primary: {
      main: "#bf360c",
    },
  },
});

let inisialToDos = [
  {
    id: uuidv4(),
    title: "المهمة الأولى",
    description: "التفاصيل الخاصة بالمهمة الأولى",
    isComplete: false,
  },
  {
    id: uuidv4(),
    title: "المهمة الثانية",
    description: "التفاصيل الخاصة بالمهمة الثانية",
    isComplete: false,
  },
  {
    id: uuidv4(),
    title: "المهمة الثالثة",
    description: "التفاصيل الخاصة بالمهمة الثالثة",
    isComplete: false,
  },
];

function App() {
  const [toDos, setToDos] = useState(inisialToDos);

  return (
    <ThemeProvider theme={theme}>
      <ToDoProvider>
        <SnackBarPovider>
          <div className="App">
            <ToDoList />
          </div>
        </SnackBarPovider>
      </ToDoProvider>
    </ThemeProvider>
  );
}

export default App;
